// BL-2467 (PRJ-93 INBOX-2) — the @Inbox's routes. Self-scoped: a person reads
// and changes only their own items at a house they belong to, keyed on the
// session, never on a body-supplied person (ADR 062 — Access Grants).

import { responseType } from '@auctogon/core/api/registry';
import { defineAdminRoute } from './define-admin-route';
// Type-only imports (erased at build) — keep the registry client-bundle-safe.
import type { StaffInboxPageDto, StaffInboxReadStateDto } from '../../schemas/responses/staff-inbox';

/** The caller's own @Inbox — nobody else's, so no grant applies. */
const SELF = { none: "self — the caller's own @Inbox, keyed on their session" } as const;

export const inbox = {
  list: defineAdminRoute({
    path: '/api/inbox',
    params: {},
    methods: {
      GET: {
        grant: SELF,
        tenant: { from: 'input', field: 'tenantId', in: 'query' },
        response: responseType<StaffInboxPageDto>(),
      },
    },
  }),
  read_state: defineAdminRoute({
    path: '/api/inbox/read-state',
    params: {},
    methods: {
      POST: {
        grant: SELF,
        tenant: { from: 'input', field: 'tenantId', in: 'body' },
        response: responseType<StaffInboxReadStateDto>(),
      },
    },
  }),
};
